import TRTC from 'trtc-js-sdk';
import {
  sendMessageService,getUserSignService,dismissRoomService
} from '../../../api/chart/chart/sendMessage.js'
export default class MeetingUtil {
  constructor(isVideo, controlId,childControlId, users, page) {

    this.isVideo = true
    this.isAudio = true
    this.timer = null
    if (!isVideo) {
      this.isVideo = false
    }
    this.waitTimer = 0

    this.controlId = controlId
    this.childControlId=childControlId
    this.roomId = null
    this.users = users
    this.addUsers = []
    this.currentUserId='administrator'
    this.inroom = false
    this.page = page
    this.userSign=null
    this.client=null
    this.localStream=null
    this.publish=false
  }
  getRoomId() {
    return this.roomId
  }

  closeMeeting() {
    let that = this
    let _users="";
    if(that.users){
      for(let i=0;i<that.users.length;i++){
         if(_users){
           _users+=",";
         }
         _users+=that.users[i]
      }
    }
    if (this.client) {
      this.client.leave().then(() => {
          console.log("退房成功")
          if (that.timer) {
            clearInterval(that.timer)
            that.timer = null
          }
          that.waitTimer = 0
          dismissRoomService({roomId:that.roomId,users:_users}).then((res)=>{
            that.page.setDialogHidden()
          })
          //that.page.btnName = "呼  叫"
        }).catch(error => {
          console.error('退房失败 ' + error);
          // 错误不可恢复，需要刷新页面。
        });
    }


  }
  createMeeting() {

    let that = this
    that.roomId = "1234567" //暂时固定
    that.waitTimer=0;
    if(this.timer){
      clearInterval(this.timer)
      this.timer=null
    }
    this.timer=setInterval(function(){
      that.waitTimer++
      if(that.waitTimer>=60){
        that.page.hideNotWaiting()
        that.waitTimer=0
      }
    },1000)
    let _users="";
    if(that.users){
      for(let i=0;i<that.users.length;i++){
         if(_users){
           _users+=",";
         }
         _users+=that.users[i]
      }
    }
    dismissRoomService({roomId:that.roomId,users:_users}).then((res2)=>{
      getUserSignService().then((res)=>{
        that.userSign=res;
        that.client = TRTC.createClient({
          mode: 'rtc',
          sdkAppId: 1400426865,
          userId: that.currentUserId,
          userSig: that.userSign
        });

        that.client.on('connection-state-changed', event => {
          const prevState = event.prevState;
          const curState = event.state;
          console.error("=======prevState==="+prevState)
          console.error("=======curState==="+curState)
        });
        that.client.on('stream-added', event => {
          const remoteStream = event.stream;
         const userId = remoteStream.getUserId();
          if (remoteStream.getUserId() === that.currentUserId) {
                 that.client.unsubscribe(remoteStream);
           } else {
             console.info('subscribe to this remote stream');

             that.client.subscribe(remoteStream);
           }
          //that.page.btnName = '通话中'
          console.info('远端流增加: ' + remoteStream.getId());
          console.info('远端流增加userId: ' + remoteStream.getUserId());
           that.page.hideNotWaiting()

        });
        that.client.on('stream-removed', event => {
          //that.page.btnName = "呼  叫"
          const remoteStream = event.stream
          remoteStream.stop();

          const id = remoteStream.getId();
          try{
            document.querySelector("#video_"+id).remove()
          }
          catch(e){

          }
          // try{
          //   document.querySelector("#"+id).remove()
          // }
          // catch(e){

          // }
          console.log('远端流移除: ' + remoteStream.getId());
        });
      that.client.on('peer-join', evt => {
        const userId = evt.userId;
        that.page.hideNotWaiting()
        console.log('peer-join ' + userId);
        if (userId !==that.currentUserId ) {
          let find = false
          for (let i = 0; i < that.addUsers.length; i++) {
            if (that.addUsers[i] == remoteStream.getUserId()) {
              find = true
            }
          }
          if (!find) {
            that.addUsers.push(userId)
          }
        }
      });
    // fired when a remote peer is leaving the room
    that.client.on('peer-leave', evt => {
      const userId = evt.userId;
      for (let i = that.addUsers.length - 1; i >= 0; i--) {
        if (that.addUsers[i] == userId) {
          that.addUsers.splice(i, 1)
           //that.client.unsubscribe(remoteStream);
        }
      }
    });
        that.client.on('stream-subscribed', event => {
          const remoteStream = event.stream;
          console.info('远端流订阅成功：' + remoteStream.getId());
          that.page.hideNotWaiting()

          // let find = false
          // for (let i = 0; i < that.addUsers.length; i++) {
          //   if (that.addUsers[i] == remoteStream.getUserId()) {
          //     find = true
          //   }
          // }
          // if (find) {
           remoteStream.play(that.childControlId+ remoteStream.getUserId());
         // }
          // 播放远端流

        });
        that._join()
      })
    })
  }
  _join() {
    let that = this
    if(!this.localStream){
      this.localStream = TRTC.createStream({
        userId: 'administrator', //根据发起者信息获取
        audio: this.isAudio,
        video: this.isVideo,
        echoCancellation:true,
        noiseSuppression:true,
        autoGainControl:true
      });
    }

    let options = {
      roomId: this.roomId
    }
    that.client.join(options).catch(error => {
      console.error('进房失败 ' + error);
    }).then(() => {
      console.log('进房成功');
      that.inroom = true
      that.localStream.initialize().catch(error => {
        console.error('初始化本地流失败 ' + error);
      }).then(() => {
        console.log('初始化本地流成功');
        that.localStream.play(that.controlId);
        that.client.publish(that.localStream).catch(error => {
          console.error('本地流发布失败 ' + error);
        }).then(() => {
          that._sendMessage(that)
          that.publish=true
          console.log('本地流发布成功');
        });
      });
    });
  }
  
  _sendMessage(that) {
    if (that.users) {
      for (let i = 0; i < that.users.length; i++) {
        sendMessageService({
          gh: that.users[i],
          roomId:that.roomId
        })
      }
    }
  }

}



// WEBPACK FOOTER //
// ./src/components/map/components/MeetingUtil.js